import { IAssignment } from '@medely/types';
import { Box, Heading, HStack, Label, Text } from '@medely/ui-kit';
import { centsToCurrency, DisplayHelpers } from '@mp/utils';
import React from 'react';
import { AssignmentCompensationPayRates } from './components/AssignmentCompensationPayRates';
import { TaxInfo } from './components/TaxInfo';
import { DetailsBanners } from './components/DetailsBanners';

type AssignmentCompensationInfoProps = {
  assignment: IAssignment & { assignment_request_status?: string };
  smallIcon?: boolean;
};

export const AssignmentCompensationInfo = ({
  assignment,
  smallIcon = false,
}: AssignmentCompensationInfoProps) => {
  const showTaxInfo = assignment.taxable_amount_cents && assignment.is_w2;
  const isOfferSent = assignment.is_w2 && assignment.assignment_request_status === 'offer_sent';

  return (
    <Box testId="compensation-group">
      <Box py={2}>
        <Heading size="s" color="text.primary" testId="assignment-details-compensation-title">
          Compensation
        </Heading>
      </Box>
      {showTaxInfo && <TaxInfo assignment={assignment} />}
      <HStack testId="compensation-group-gross-weekly-pay" justifyContent="space-between">
        <Label size="l" testId="compensation-group-gross-weekly-pay-title">
          Estimated weekly pay
        </Label>
        <Label size="l" testId="compensation-group-gross-weekly-pay-per-week-cents">
          {centsToCurrency(assignment.pay_per_week_cents || 0)}
        </Label>
      </HStack>
      <Text size="l">{DisplayHelpers.assignment.expectedHours(assignment)} hrs/week</Text>
      {Boolean(assignment.one_time_bonus_burden_cents) && (
        <HStack justifyContent="space-between" mt={2} mb={1} testId="assignment-compensation-bonus">
          <Label size="l" testId="assignment-compensation-bonus-title">
            Bonus
          </Label>
          <Label size="l" testId="compensation-group-boost-bonus-cents">
            {centsToCurrency(assignment.one_time_bonus_burden_cents)}
          </Label>
        </HStack>
      )}
      {isOfferSent && (
        <Box pt={2}>
          <AssignmentCompensationPayRates assignment={assignment} />
        </Box>
      )}
      <DetailsBanners assignment={assignment} smallIcon={smallIcon} />
    </Box>
  );
};
